module.exports = __webpack_public_path__ + "static/img/oval58.94d78c62.png";